import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const Title = styled.h1`
  text-align: center;
  font-family: sans-serif;
  font-size: 1.35rem;
  line-height: 1.1;
  font-weight: 700;
  margin: 20px auto;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: start;
  min-width: 854px;
  margin: 0 auto;
`;

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: 417px 280px 400px auto auto auto;
  gap: 0.5rem;
  min-height: 31px;
  width: 100%;
`;

export const FieldLabel = styled.label`
  font-weight: 600;
  display: flex;
  margin-top: 0.5rem;
  justify-content: flex-end;
  text-align: right;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.75rem;
  margin-left: 0.2rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin: 1rem auto;
`;
